export default "__VITE_ASSET__BFnF5EFE__"